<script lang="ts">
  import { ModuleSetting } from "module/store/ModuleSettings";
  import { getLocationIcon, type SearchItem } from "module/searchLib";
  import { stores } from "module/store/SettingsStore";
  import type { SearchResultItemProps } from "../SearchControllers";

  let {
    density,
    tooltips = "LEFT",
    resultItem,
    selected,
    selectedAction,
    callAction,
  }: SearchResultItemProps = $props();

  let tooltipModeSetting = stores[ModuleSetting.SEARCH_TOOLTIPS];
  let enhancedTooltips = stores[ModuleSetting.ENHANCED_TOOLTIPS];

  let tooltipMode = $tooltipModeSetting;

  let item = resultItem.item as SearchItem;
  let { formattedMatch, actions, defaultAction } = $derived(resultItem);

  function getTooltip(
    item: SearchItem,
    side: "RIGHT" | "LEFT" | "OFF",
    tooltipMode: string
  ): string {
    if (tooltipMode === "off" || side === "OFF") return "";

    const showImage = tooltipMode === "full" || tooltipMode === "image";
    const img =
      showImage && item.img
        ? `<img src="${item.img}" style="max-width: 80px; margin: 0 auto 0.5rem auto; border-radius: 10px;"/>`
        : "";

    const text =
      tooltipMode !== "image"
        ? `<p style='margin:0;text-align:center; max-width: 260px;'>${item.name}</p>
           <p style='text-align: center;font-size: 90%; opacity:0.8;margin:0; max-width: 260px;'>${item.icon} ${item.tooltip}</p>`
        : "";

    return img + text;
  }
</script>

<li
  class:search-selected={selected}
  role="option"
  aria-selected={selected}
  data-tooltip={getTooltip(item, tooltips, $tooltipModeSetting)}
  class={$enhancedTooltips ? "content-link" : undefined}
  data-uuid={item.uuid}
  data-hash={item.anchor?.slug}
  id={`result_${item.id}${item.uuid}`}
>
  <a
    draggable="true"
    title={tooltipMode === "off" || tooltipMode === "image"
      ? `${item.name} - ${item.tooltip}`
      : undefined}
    on:dragstart={(event) =>
      event.dataTransfer?.setData("text/plain", JSON.stringify(item.dragData))}
    on:click|stopPropagation={(e) =>
      callAction({ actionId: defaultAction, item, shiftKey: e.shiftKey })}
  >
    {#if item.img}
      <img src={item.img} class="doc-image" draggable="false" />
    {:else}
      {@html item.icon}
    {/if}
    {#if density === "spacious"}
      <div class="two-line-item">
        <span class="title">
          {@html formattedMatch || item.name}
        </span>
        <span class="sub"> {item.tooltip} {@html getLocationIcon(item)}</span>
      </div>
    {:else}
      <span class="title">
        {@html formattedMatch || item.name}
      </span>
      <span class="sub">{item.tagline}</span>
      {@html getLocationIcon(item)}
    {/if}
    <span class="action-icons">
      {#each actions || [] as action}
        {#if action.img}
          <i
            draggable="false"
            class="action-icon"
            class:selected={selected &&
              (selectedAction
                ? action.id === selectedAction
                : action.id == defaultAction)}
            data-tooltip={action.title}
            data-tooltip-direction="UP"
            data-action-id={action.id}
            on:click|stopPropagation={(e) =>
              callAction({ actionId: action.id, item, shiftKey: e.shiftKey })}
            ><img src={action.img} /></i
          >
        {:else}
          <i
            class="{action.icon} action-icon"
            class:selected={selected &&
              (selectedAction
                ? action.id === selectedAction
                : action.id == defaultAction)}
            data-tooltip={action.title}
            data-tooltip-direction="UP"
            data-action-id={action.id}
            on:click|stopPropagation={(e) =>
              callAction({ actionId: action.id, item, shiftKey: e.shiftKey })}
          ></i>
        {/if}
      {/each}
    </span>
  </a>
</li>
